import { render, staticRenderFns } from "./PromoDetail.vue?vue&type=template&id=1880a640&lang=pug&"
import script from "./PromoDetail.vue?vue&type=script&lang=js&"
export * from "./PromoDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports